import React, { Component } from 'react';
import Button from 'shared/lib/components/Button';
import map from 'lodash/map';
import LandingBlockThreeUp from 'shared/lib/components/LandingBlockThreeUp';
import LandingBlockPartner from 'shared/lib/components/LandingBlockPartner';
import LandingBlockPriceComparison from 'shared/lib/components/LandingBlockPriceComparison';
import LandingBlockCTABanner from 'shared/lib/components/LandingBlockCTABanner';
import seo from 'shared/lib/seo';
import * as analytics from 'shared/lib/analytics';
import './LandingIframeComics.css';
import imageMarkelLogo from './images/logo-markel.png';
import imageSureLogo from './images/logo-sure.png';
import COLLECTIBLES_CATEGORIES from 'shared/lib/constants/collectiblesCategories';

class LandingIframeComics extends Component {
  componentDidMount() {
    seo.setProps({
      title: `Comic Book Insurance | Sure`,
      description: `Get Comic Book Insurance through Sure to protect your treasures.`,
      url: `https://www.sureapp.com/_/comic-book-insurance`,
      robots: 'noindex, nofollow',
    });
    analytics.page('Collectibles - Landing', {
      categoryCode: 'comic_books',
    });
    analytics.track('Collectibles - Landing Page Viewed', {
      categoryCode: 'comic_books',
      noninteraction: 1,
    });
  }

  render() {
    const categoryConfig = COLLECTIBLES_CATEGORIES.comic_book;

    return (
      <div className="LandingIframeComics">
        <div className="LandingIframeComics-hero">
          <div className="LandingIframeComicsContainer">
            <img
              className="LandingIframeComics-hero-logo"
              alt="Powered by Sure"
              src={imageSureLogo}
            />
            <h1 className="LandingIframeComics-hero-heading">
              Your comic books are worth protecting
            </h1>
            <p className="LandingIframeComics-hero-pitch">
              You’ve invested your time and money into building your collection.
              Now protect your property and your wallet with our competitive
              rates and comprehensive coverage.
            </p>
            <div className="LandingIframeComics-hero-ctaContainer">
              <Button
                className="LandingIframeComicsCTA LandingIframeComics-cta"
                to={`/collectibles/comic-book-insurance/start`}
                sureStyle="secondary"
              >
                Check our prices
              </Button>
              <p className="LandingIframeComics-ctaDisclaimer">
                We'll never sell or share your personal information
              </p>
            </div>
          </div>
        </div>

        <LandingBlockThreeUp
          title="What does collectibles insurance cover?"
          subtitle="Whether you’re collecting as an investment or as a hobby or passion project, purchasing collectibles insurance guarantees your precious items will be protected."
          cards={map(categoryConfig.threeUps, threeUp => ({
            icon: threeUp.image,
            heading: threeUp.title,
            description: threeUp.description,
          }))}
          isIconImage
        />

        <LandingBlockPartner
          title="We’ve partnered with the best to keep your investment safe"
          partnerName="Markel"
          logo={imageMarkelLogo}
        >
          <p>
            Insuring your collectibles doesn’t need to involve paperwork and
            pain. We’ve partnered with <strong>Markel</strong> to bring you an
            affordable, yet comprehensive plan, that you can purchase
            instantly—right from the trade show or shop.
          </p>
          <p>
            Markel has been a trusted insurer of personal property since 1988.
            Get covered through Sure and manage all of your policies and claims
            through a single, user-friendly platform.
          </p>
        </LandingBlockPartner>

        <LandingBlockPriceComparison
          title="Here’s what it costs"
          subtitle="Pricing is just $150 a year for collections up to $75,000 in value (and pretty reasonable beyond that collection size, too). Yea, we know: “wow”."
        />

        <LandingBlockCTABanner
          title="If it’s worth collecting, it’s worth protecting"
          subtitle={`Let us pair you with the best policy for you and your comic books.`}
          lightTheme
          ctaText="Check our prices"
          ctaStyle="secondary"
          linkTo={`/collectibles/comic-book-insurance/start`}
        />

        <div className="LandingIframeComics-footer">
          <div className="Container">
            <p>
              Content and associated insurance products are provided by Sure
              HIIS Insurance Services, LLC (“Sure”), a licensed seller of
              insurance. The above does not in any way constitute an endorsement
              or referral by the hosting company of Sure’s products or services.
              Products may not be offered in all states. Read our{' '}
              <a
                href="https://www.sureapp.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>{' '}
              and{' '}
              <a
                href="https://www.sureapp.com/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default LandingIframeComics;
